import initQrPopup from 'components/qr-popup'
import { initForm } from './components/form-handling'
import initButtonVisibility from 'landings/__assets__/scripts/components/scroll-button'
import { initWebWorker } from 'landings/__assets__/scripts/services/worker-handler'
import initExitPopup from 'src/landings/__assets__/scripts/components/exit-popup'
import initScrollRevealAnimation from 'landings/__assets__/scripts/components/scroll-reveal-animation'
import { initCurrencyLandingsAnimations } from 'landings/__assets__/scripts/components/currency-land-animations'
import { scrollToElement } from 'landings/__assets__/scripts/components/scroll-to-element'
import { initConditionalRedirects } from 'components/conditional-redirects'

initQrPopup()
initButtonVisibility()
initForm(true)
initWebWorker()
initExitPopup()
initScrollRevealAnimation()
initCurrencyLandingsAnimations()
scrollToElement()
initConditionalRedirects()
